import { format, parseISO, isValid } from 'date-fns';
import { useState, useEffect } from 'react';
import { DayPicker } from 'react-day-picker';
import { usePopper } from 'react-popper';
import 'react-day-picker/dist/style.css';
import './Datepicker.scss';

export default (props) => {

    

    const [selectedDate, setSelectedDate] = useState(props.initialDate);
    const [showCalendar, setshowCalendar] = useState(false);
    
    const [referenceElement, setReferenceElement] = useState(null);
    const [popperElement, setPopperElement] = useState(null);
    const { styles, attributes } = usePopper(referenceElement, popperElement, {});

    const closeSidemenu = () => {
        setshowCalendar(false);
    }

    useEffect(() => {
        document.body.addEventListener('click', closeSidemenu );

        return function cleanup() {
            window.removeEventListener('click', closeSidemenu );
        } 
    },[]);

    return (
        <div className="datepicker-wrapper">
            <input 
                type="text" 
                name="pob"
                className="form-control text" 
                value={format(parseISO(selectedDate), 'dd LLLL Y' )}
                readOnly
                ref={setReferenceElement}
                onClick={(e)=>{ e.preventDefault();e.stopPropagation(); setshowCalendar(!showCalendar)}}
                />
                {
                    showCalendar && 
                        <div ref={setPopperElement} style={styles.popper} className="rdp-wrapper" onClick={(e) => {e.preventDefault();e.stopPropagation();}} >
                            <DayPicker 
                                mode="single"
                                name="dob"
                                fromYear={1950} 
                                toYear={2030} 
                                defaultMonth={ parseISO(selectedDate) }
                                selected={ parseISO(selectedDate) } 
                                captionLayout="dropdown"                                
                                onSelect={function(value){

                                    if(typeof value != 'undefined')
                                    {
                                        var stringSelectedDate = format(value, 'y-MM-dd' );
                                        
                                        setSelectedDate(stringSelectedDate);
    
                                        props.onSelect(stringSelectedDate);

                                        setshowCalendar(false);
                                    }

                                }}
                            />
                        </div>
                }
        </div>
    );
};